var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100%"}},[(_vm.$route.path === '/plan/shopping')?_c('page',[_c('ZuiHeader'),_vm._v(" "),_c('SubPageTemplate',{attrs:{"page-title":"购的开心","dynamically-tab":"","wenqun-item":"","buy-sub-img":"","list-title":"","pid":_vm.$cid.play.gouDeKaiXin,"default-tab-id":_vm.tabId,"page-size":3,"type":"article","video-mask":false},on:{"article-click":_vm.articleClick}}),_vm._v(" "),_c('ZuiFooter')],1):_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-44e4975b","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/plan/shopping.vue
// module id = 1412
// module chunks = 0